//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

//store
const TipovalorListadesagregacion = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/TipovalorListadesagregacion`,
    state: {
        desagregaciones: [],
        desagregacionesexportar: [],
    }
}).get({
    action: "get_TipovalorListadesagregacion", 
    path: function (obj) {
        return `/List/${obj.idindicador}/${obj.principal}`;
    },     
    onSuccess: (state, payload ) => {
        state.desagregaciones = payload.data;
    }
}).get({
    action: "get_desagregacionbytipovalor", 
    path: function (obj) {
        return `/List/${obj.idtipovalor}`;
    },     
    onSuccess: (state, payload ) => {
        state.desagregaciones = payload.data;
    }
}).post({
    action: "get_desagregacionbytipovalorexportar", 
    path: function () {
        return `/exportartipovalor`;
    },     
    onSuccess: (state, payload ) => {
        state.desagregacionesexportar = payload.data;
    }
}).post({
    action: "post_estadodesagregacion",
    path: function (obj) {
        return `/inactivar/${obj.idtipovalor}/${obj.iddesagregacion}/${obj.state}`;
    }, 
    onSuccess: (state, payload ) => {
        state.desagregaciones = payload.data;
    }
}).post({
    action: "post_asignardesagregaciones",
    path: function (obj) {
        return `/asignardesagregaciones`;
    }, 
    onSuccess: (state, payload) => {
        state.desagregaciones = payload.data;
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).delete({
    action: "Deletelistadesagregacion",
    path: function (obj) {
        return `${obj.idindicador}/${obj.idtipovalor}/${obj.iddesagregacion}`
    },
    onSuccess: (state, payload) => {state.desagregaciones = payload.data; },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

TipovalorListadesagregacion.getters = {
    gTipovalorListadesagregacion: state => {
        return state.desagregaciones;
    },
    gTipovalorListadesagregacionExportar: state => {
        return state.desagregacionesexportar;
    }
}

export default TipovalorListadesagregacion;